import { render, staticRenderFns } from "./MoveFollowers.vue?vue&type=template&id=3b56091a"
import script from "./MoveFollowers.vue?vue&type=script&lang=js"
export * from "./MoveFollowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports